import React, { useState, useEffect } from 'react'
import DebtManagement from './DebtManagement'
import DebtManagementDashboard from './DebtManagementDashboard'
import KPIDebtManagementDashboard from './KPIDebtManagementDashboard'
import KPILoanManagementDashboard from './KPILoanManagementDashboard'
import LoanDashboard from './LoanDashboard'
import LoanPortfolioReview from './LoanPortfolioReview'
import PaymentsCollected from './PaymentsCollected'
import RevenueOperationalExpenses from './RevenueOperationalExpenses'
import BackLogo from '../../../../images/rewampimages/Chevron.png'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { getNBFCList } from './DebtListActionCreator'
import moment from 'moment'
import NPALeadsContainer from './NPALeads.container'

const InitalDate = (type) => {


    if (type === 'fromDate') {
        const year = new Date().getFullYear();
        const FirstDay = moment(`${year}-01-01`);
        const fromdate = FirstDay.format('YYYY-MM-DD');
        // const fromdate = moment().subtract(1, 'month').format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }

}

export default function DebtListIndividual({ pageViewHandler, admin }) {
    const [activeTab, setActiveTab] = useState('debtManagement')
    const [detailView, setDetailView] = useState(false)
    const [nbfcList, setnbfcList] = useState([])
        const [commonFilters, setCommonFilters] = useState({
            fromDate: InitalDate('fromDate'),
            toDate: InitalDate('toDate'),
            nbfc: "",
            product: "",
        })
    
    
        const handleCommonFilters = (value, type) => {
            setCommonFilters((prev) => ({
                ...prev,
                [type]: value
            }))
        }

    const maxHeight = window.innerWidth > 1300 ? '60px' : '75px'
  
    const BackBtnStyle = {
        height: maxHeight,
        width: '100px',
        padding: '10px',
        textAlign: 'center',
        backgroundColor: '#1D3557',
        color: '#fff',
        cursor: 'pointer',
    }

    useEffect(() => {
        getNBFCListAPI()
    }, [])

    const getNBFCListAPI = () => {
        getNBFCList((callback) => {
            console.log(callback)
            if (callback) {
                setnbfcList(callback)
            } else {
                setnbfcList([])
            }
        })
    }
    const handleTabs = (type) => {
        setActiveTab(type)
    }

    const detailViewHandler = (type) => {
        setDetailView(type)
    }

    return (
        <>
            <div className="DebtListMain">
                {
                    !detailView ?
                        <div className="tabs" style={{marginTop:'25px',position:'initial',borderRadius:'15px'}} >

                            <div className="row">
                                <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'debtManagement' ? 'active' : ''}`} onClick={() => handleTabs('debtManagement')} style={{ height: maxHeight }} id="debtListTabs">
                                    <h5>Debt Management</h5>
                                </div>
                                <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'KPIDebtManagement' ? 'active' : ''}`} onClick={() => handleTabs('KPIDebtManagement')} style={{ height: maxHeight }} id="debtListTabs">
                                    <h5>KPI Debt Managment</h5>
                                </div>
                                {/* <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'DebtManagmentDashboard' ? 'active' : ''}`} onClick={() => handleTabs('DebtManagmentDashboard')} style={{ height: maxHeight }} id="debtListTabs">
                            <h5>Debt Management Dashboard</h5>
                        </div> */}
                                <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'KPILoanManagmentDashboard' ? 'active' : ''}`} onClick={() => handleTabs('KPILoanManagmentDashboard')} style={{ height: maxHeight }} id="debtListTabs">
                                    <h5>KPI Loan Managament</h5>
                                </div>
                                <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'Paymentscollected' ? 'active' : ''}`} onClick={() => handleTabs('Paymentscollected')} style={{ height: maxHeight }} id="debtListTabs">
                                    <h5>Payments collected</h5>
                                </div>
                                <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'LoanPortfolio' ? 'active' : ''}`} onClick={() => handleTabs('LoanPortfolio')} style={{ height: maxHeight }} id="debtListTabs">
                                    <h5>Loan Portfolio Review</h5>
                                </div>
                                {/* <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'RevenueOperation' ? 'active' : ''}`} onClick={() => handleTabs('RevenueOperation')} style={{ height: maxHeight }} id="debtListTabs">
                                    <h5>Revenue & Operational Expenses</h5>
                                </div> */}
                                {/* <div className={`col-sm-1 col-xs-12 box customwidth ${activeTab == 'LoanDashboard' ? 'active' : ''}`} onClick={() => handleTabs('LoanDashboard')} style={{ height: maxHeight }} id="debtListTabs">
                                <h5>Loan Dashboard</h5>
                            </div> */}
                            </div>
                        </div>
                        : ''}
                <div className="container-fluid Sections" style={{margin:'20px 0'}}>
                    {/* <div className="row">
                        <div className="col-sm-4 " style={{ marginTop: '15px', marginBottom: '30px' }}>
                            <button style={{ color: '#223d64', fontWeight: '400', display: 'flex', border: '1px solid #267dff', borderRadius: '6px', padding: '8px 10px' }} onClick={(e) => pageViewHandler(e, 'landingPage')} ><ArrowBackIosNewIcon style={{ marginTop: '1px' }} />&nbsp;Back</button>
                        </div>
                    </div> */}
                    {
                        activeTab == 'debtManagement' || activeTab == 'KPILoanManagmentDashboard' ?
                            <NPALeadsContainer admin={admin} detailViewHandler={detailViewHandler} activeTab={activeTab}
                            handleCommonFilters={handleCommonFilters}
                                commonFilters={commonFilters}
                            />
                            // <DebtManagement nbfcList={nbfcList} />
                            : ''
                    }
                    {
                        activeTab == 'KPIDebtManagement' ?
                            <KPIDebtManagementDashboard nbfcList={nbfcList}
                            handleCommonFilters={handleCommonFilters}
                                commonFilters={commonFilters}
                            />
                            : ''
                    }
                    {
                        activeTab == 'DebtManagmentDashboard' ?
                            <DebtManagementDashboard />
                            : ''
                    }

                    {
                        activeTab == 'Paymentscollected' ?
                            <PaymentsCollected nbfcList={nbfcList}
                            handleCommonFilters={handleCommonFilters}
                                commonFilters={commonFilters}
                            />
                            : ''
                    }
                    {
                        activeTab == 'RevenueOperation' ?
                            <RevenueOperationalExpenses
                            handleCommonFilters={handleCommonFilters}
                                commonFilters={commonFilters}
                            />
                            : ''
                    }
                    {
                        activeTab == 'LoanPortfolio' ?
                            <LoanPortfolioReview nbfcList={nbfcList}
                            handleCommonFilters={handleCommonFilters}
                                commonFilters={commonFilters}
                            />
                            : ''
                    }
                    {
                        activeTab == 'LoanDashboard' ?
                            <LoanDashboard />
                            : ''
                    }
                </div>

            </div>
        </>
    )
}
